import { Dialog } from '@base-ui/react/dialog'
import { XIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { IconButton } from '../IconButton/IconButton'
import styles from './Drawer.module.css'

export function Drawer({
  open,
  onOpenChange,
  label,
  close,
  children,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  label: string
  close: string
  children: ReactNode
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Backdrop className={styles.backdrop} />
        <Dialog.Popup className={styles.popup} aria-label={label}>
          <Dialog.Close
            render={
              <IconButton className={styles.close} label={close}>
                <XIcon />
              </IconButton>
            }
          />
          {children}
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
